import fetch from 'utils/fetch';

export function orderProductList(productId,productName,pageSize,currentPage) {
    const data = {
        productId,
        productName,
        pageSize,
        currentPage
    };
    return fetch({
        url: '/orderProductList',
        method: 'get',
        params : data
    });
}


// WEBPACK FOOTER //
// ./src/api/orderProduct.js